import type { FC } from 'react';


import { TrackedNotificationBox } from '@eneco/components/TrackedNotificationBox/TrackedNotificationBox';
import { useTranslation } from '@eneco/i18n';
import { Control, FieldErrorsImpl, useFormState } from 'react-hook-form';

import { FormValues } from '../../ConfirmationStep.schema';

type FieldErrorNotificationProps = {
  control: Control<FormValues>;
};

const getErrorType = (errors: FieldErrorsImpl<FormValues>) => {
  const hasEmailError = !!errors.email?.message;
  const meterErrors = Object.entries(errors?.meters || {})
    .flatMap(([_, meter]) => Object.keys(meter))
    .filter((error, index, errors) => index === errors.indexOf(error));

  const [error] = meterErrors;

  if (meterErrors.length > 1 || (hasEmailError && error)) return 'multipleErrors';
  if (hasEmailError) return 'email';

  return error;
};

export const FieldErrorNotification: FC<FieldErrorNotificationProps> = ({ control }) => {
  const { errors } = useFormState({ control });
  const { t } = useTranslation();

  const errorType = getErrorType(errors);

  if (!errorType) return null;

  return (
    <TrackedNotificationBox
      variant="warning"
      isAlert={false}
      title={t(`${errorType}ErrorTitle`)}
      text={t(`${errorType}ErrorText`)}
    />
  );
};
